import axios from "axios";
import router from '@/router'
import {Notify} from "vant";
import xyUtils from '@/common/utils'

axios.interceptors.request.use(
  config => {
    let token = xyUtils.getCookie('.XYTOKEN')
    if (token !== undefined) {
      config.headers['XYTOKEN'] = token
    }
    return config
  },
  _error => {
    return Promise.reject(_error)
  }
)

const xyapi = {
  async get (url, data, noMsgWin) {
    data = Object.assign({}, data, { _: +new Date() })
    try {
      let res = await axios.get(url, { params: data })
      return new Promise((resolve, reject) => {
        if ((res.status >= 200 && res.status < 300) || (res.status === 304)) {
            resolve(res.data)
          if (!res.data.success && !noMsgWin) {
            xyUtils.unloading()
            Notify({type:'danger', message: res.data.msg})
          }
        } else {
          xyUtils.unloading()
          reject(res)
        }
      })
    } catch (err) {
      //console.log(err.message)
      if (err.message.indexOf('401') !== -1) {
        router.replace({ path: '/error401' })
      }
      if (err.message.indexOf('404') !== -1) {
        router.replace({ path: '/error404' })
      }
     // Notify({type:'danger', message:url})
    }
  },
  async post (url, data, noMsgWin, config = {}) {
    try {
      let res = await axios.post(url, data, config)
      return new Promise((resolve, reject) => {
        if ((res.status >= 200 && res.status < 300) || (res.status === 304)) {
          resolve(res.data)
          if (!res.data.success && !noMsgWin) {
            xyUtils.unloading()
            Notify({type:'danger', message: res.data.msg})
          }
        } else {
          xyUtils.unloading()
          reject(res)
        }
      })
    } catch (err) {
      Notify({type:'danger', message:'服务器出错'})
      //console.log(err)
      if (err.message.indexOf('401') !== -1) {
        router.replace({ path: '/error401' })
      }
      if (err.message.indexOf('404') !== -1) {
        router.replace({ path: '/error404' })
      }
    }
  },
  async uploadPost (url, data, config = {}) {
    try {
      let res = await axios.post(url, data, config)
      return new Promise((resolve, reject) => {
        if ((res.status >= 200 && res.status < 300) || (res.status === 304)) {
          if(res) {
            resolve(res.data)
          } else {
            xyUtils.unloading()
            Notify({type:'danger', message: res.data.msg})
          }
        } else {
          xyUtils.unloading()
          reject(res)
        }
      })
    } catch (err) {
      Notify({type:'danger', message:'服务器出错'})
      console.log(err)
    }
  },
  $put (url, data, config) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'put',
        url: url,
        data: data,
        header: {
          'Content-Type': config
        }
      }).then(res => {
        if (res.status && ((res.status >= 200 && res.status < 300) || (res.status === 304))) {
          resolve(res.data)
        } else {
          reject(res)
        }
      }).catch(err => {
        reject(err)
      })
    })
  }
}
export default xyapi
